export default __webpack_public_path__ + "static/media/ic_camera.f28080a5.svg";